import { Container, Typography } from "@mui/material";

const NotFound = () => {
  return (
    <Container sx={{ textAlign: 'center', my: 10 }} >
      <Typography variant="h1" component="h1" gutterBottom>
        404 - Page Not Found
      </Typography>
      <Typography variant="h5" component="p" color='text.secondary'>
        The page you are looking for does not exist.
      </Typography>
    </Container>
  );
};

export default NotFound;